import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const CaseStudy: React.FC = () => {
  const { t } = useTranslation('about');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-20" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="card p-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 gradient-text">
              {t('shortCase.title')}
            </h2>
            <p className="text-xl text-secondary mb-8 leading-relaxed">
              {t('shortCase.description')}
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-primary-500 mb-2">
                  {t('shortCase.stats.increase')}
                </div>
                <div className="text-sm text-secondary">
                  {t('shortCase.stats.increaseLabel')}
                </div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-500 mb-2">
                  {t('shortCase.stats.faster')}
                </div>
                <div className="text-sm text-secondary">
                  {t('shortCase.stats.fasterLabel')}
                </div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-500 mb-2">
                  {t('shortCase.stats.satisfaction')}
                </div>
                <div className="text-sm text-secondary">
                  {t('shortCase.stats.satisfactionLabel')}
                </div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-500 mb-2">
                  {t('shortCase.stats.roi')}
                </div>
                <div className="text-sm text-secondary">
                  {t('shortCase.stats.roiLabel')}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CaseStudy;
